import { render, staticRenderFns } from "./PctDisc.vue?vue&type=template&id=7b12aaeb"
import script from "./PctDisc.vue?vue&type=script&lang=js"
export * from "./PctDisc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports